<template>
  <div id="top-slider-container">
    <swiper :options="topSwiper" ref="topSwiper" class="us-top-slider-swiper">               
        <swiper-slide  class="us-top-slider-swiper-slide">
          <div class="us-top-slider-swiper-slide-image-container" v-bind:style="{ 'background-image': 'url(/bilder/bigpic/cover_kata.jpg)' }">
            <div class="w3-display-left w3-text-white" style="padding:48px">           
              <div class="dollitDing">Gemeinsam reist man weniger allein… </div>                          
          </div>
          </div>
          <div class="us-journey-pic-copyright-top">©kesipun - stock.adobe.com</div> 
        </swiper-slide>
        <swiper-slide  class="us-top-slider-swiper-slide">
          <div class="us-top-slider-swiper-slide-image-container" v-bind:style="{ 'background-image': 'url(/bilder/bigpic/cover_wika1.jpg)' }">
            <div class="w3-display-left w3-text-white" style="padding:48px">           
              <div class="dollitDing">Gemeinsam reist man weniger allein… </div>            
          </div>
          </div>
           <div class="us-journey-pic-copyright-top">©panaramka - stock.adobe.com</div> 
        </swiper-slide>
        <div class="swiper-pagination"  slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </swiper> 
  
      <div class="us-sozial-media">
        <a target="new" href="https://www.facebook.com/LWW-Bustouristik-GmbH-174152742631691" style="color:rgba(0, 0, 0, 0.5);"><fai :icon="['fab', 'facebook-square' ]"></fai></a>
        <a target="new" href="https://goo.gl/maps/TBsKk23xdVAKZr4J8" style="color:rgba(0, 0, 0, 0.5);"><fai :icon="['fab', 'google-plus-square' ]"></fai></a>
        <a target="new" href="https://instagram.com/lwwbustouristik/" style="color:rgba(0, 0, 0, 0.5);"><fai :icon="['fab', 'instagram' ]"></fai></a>
      </div>
  
  </div>  
</template>

<script>
  export default {
    name: 'topslider',
    computed: {
      swiper() {
          return this.$refs.topSwiper.swiper
      }
    }, 
    data() {
      return {
        // image: "../assets/images/test.jpg",
        topSwiper: { 
            direction: 'horizontal', 
            slidesPerView: 1, 
            spaceBetween: 1, 
            // mousewheel:true,
            loop: true, 
            speed:2000, 
            autoplay: {
              delay: 5000,
            },
            pagination: { el: '.swiper-pagination', clickable: true, type:'bullets' }, 
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },            
        },
			
      }
    },
    methods: {
      setSliderTop(){
        var el = document.querySelector('#top-slider-container');  
            el.style.height = "0px";
            el.style.minHeight = "0px";       
      }      
    }
  }
</script>

<style>
   
   .dollitDing {
     position:absolute;
     right:10vh;
     bottom:20vh;
     font-size:3vw;
     font-weight:bold;
     padding:20px;
     background-color:rgba(0,0,0,0.4);
     color:#fff;
   }
   
   
   .us-journey-pic-copyright {
      position:absolute;
      z-index:20;
      bottom:10px;
      left:10px;
      color:#FFF;
      font-size:9px;
      text-shadow: 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3);
    }
   
   
   #top-slider-container{
      height: 100%;
      /* min-height: 100%; */
      width:100%; 
      transition: all 2s; 
      position:relative;   
    }    
    .us-top-slider-swiper {        
        width:inherit;
        height:inherit;       
    }
    .us-top-slider-swiper-slider {        
        width:inherit;
        height:inherit;
    }
    .us-top-slider-swiper-slide-image-container {
      background-repeat:no-repeat;
      background-position: 50% 0;
      background-size: cover;     
      min-height: 100%;     
    }

    .us-sozial-media {
      position:absolute;
      left:20px;
      bottom: 20px;      
      z-index:10;
      font-size:5vw;
      color: rgba(0, 0, 0, 0.5);
     
    }

    .us-sozial-media svg{
       padding-right:0.5vw;
       transition: all 1s;
    } 
    .us-sozial-media svg:hover{
      color: rgba(255, 255, 255, 0.8);
       
    } 
</style>





